export default __webpack_public_path__ + "static/media/familly.f64c042c.png";